import axios from "axios"
import useGetApi from "../useGetApi"
import useMutateApi from "../useMutateApi"

// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

// utils
import getUrl from "api/apiMap"

const useStudySearchApi = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.studySearch)}`,
    invalidateQueries: [], // TODO: limit to just study queries
    // successMsg: 'Successfully created assessment type'
  })
}

const getGlobalSearch = async (searchVal) => {
  if (!searchVal) return

  return await axios.post(`${getUrl(apiEndpoints.globalSearch)}`, {
    filter_val: searchVal
  })
}

const useGetGlobalSponsorFilter = () => {
  return useGetApi(getUrl(apiEndpoints.globalSponsorFilter), queryKeys.globalSponsorFilter)
}

const usePostGlobalSponsorFilter = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.globalSponsorFilter)}`,
    invalidateQueries: [queryKeys.globalSponsorFilter], // TODO: limit to just study queries
    successMsg: "Successfully updated sponsor filter",
  })
}

const useGetGlobalFilter = () => {
  return useGetApi(getUrl(apiEndpoints.globalFilter), queryKeys.globalFilter)
}

const usePostGlobalFilter = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: `${getUrl(apiEndpoints.globalFilter)}`,
    invalidateQueries: [queryKeys.globalFilter], // TODO: limit to just study queries
    successMsg: "Successfully updated global filter",
  })
}

export {
  useStudySearchApi,
  useGetGlobalSponsorFilter,
  usePostGlobalSponsorFilter,
  getGlobalSearch,
  useGetGlobalFilter,
  usePostGlobalFilter,
}
